export default __webpack_public_path__ + "static/media/logo_b.9cb1222f.png";